/**
 * @generated SignedSource<<c45731dfc752c8cb8c10f6ab0da6166a>>
 * @relayHash b5780c27c7fce1bb68909ce723a544b8
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b5780c27c7fce1bb68909ce723a544b8

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
export type reopenPullRequestMutation$variables = {
  pullRequestId: string;
};
export type reopenPullRequestMutation$data = {
  readonly reopenPullRequest: {
    readonly pullRequest: {
      readonly id: string;
      readonly state: PullRequestState;
      readonly viewerCanClose: boolean;
    } | null;
  } | null;
};
export type reopenPullRequestMutation$rawResponse = {
  readonly reopenPullRequest: {
    readonly pullRequest: {
      readonly id: string;
      readonly state: PullRequestState;
      readonly viewerCanClose: boolean;
    } | null;
  } | null;
};
export type reopenPullRequestMutation = {
  rawResponse: reopenPullRequestMutation$rawResponse;
  response: reopenPullRequestMutation$data;
  variables: reopenPullRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pullRequestId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "pullRequestId",
            "variableName": "pullRequestId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ReopenPullRequestPayload",
    "kind": "LinkedField",
    "name": "reopenPullRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PullRequest",
        "kind": "LinkedField",
        "name": "pullRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerCanClose",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "reopenPullRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "reopenPullRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "b5780c27c7fce1bb68909ce723a544b8",
    "metadata": {},
    "name": "reopenPullRequestMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f1988eb9010f4d1647cfd79d6cb3f637";

export default node;
